import React from 'react';
import { STANDARD_POINTS, STANDARDS_SHORT } from '../lib/standards';

// "Our Standards" for riders. variant="section" is the home page block, variant="short" the one-line reminder on /book.
export default function OurStandards({ variant = 'section' }) {
  if (variant === 'short') {
    return (
      <div data-testid="our-standards-short" className="rounded-2xl border border-white/10 bg-white/[0.02] px-5 py-4">
        <p className="text-[11px] tracking-[0.25em] uppercase text-orange-400 mb-1.5">Our Standards</p>
        <p className="text-sm text-gray-300 leading-relaxed">{STANDARDS_SHORT}</p>
      </div>
    );
  }
  return (
    <section data-testid="our-standards" className="w-full px-6 py-20 md:py-24 border-t border-gray-800 bg-black/60">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs tracking-[0.35em] uppercase text-orange-400 mb-4">Our Standards</p>
        <h2 className="text-3xl md:text-4xl font-medium text-white max-w-2xl leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          What you can expect, every ride
        </h2>
        <div className="h-px mb-10 max-w-xs" style={{ background: 'linear-gradient(90deg, rgba(249,115,22,0.6), rgba(249,115,22,0))' }} aria-hidden="true" />
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-8">
          {STANDARD_POINTS.map((p, i) => (
            <li key={p.title} data-testid={`our-standard-${i}`}>
              <h3 className="text-xl text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{p.title}</h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed">{p.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
